export default "__VITE_ASSET__BMVlExT$__"